import module from 'fanconsultores/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('app.login', {
    params: {to: {value: null}},
    data: {title: 'server.session.auth.title'},
    url: '/auth',
    controllerAs: '$ctrl',
    template: '<app-login quequed-state="quequedState"></app-login>',
    controller ($scope, $stateParams) {
      $scope.quequedState = $stateParams.to || {state: 'dashboard', params: {}}
    },
  })
})



// WEBPACK FOOTER //
// ./src/fanconsultores/routes/app/login.js